// extracted by mini-css-extract-plugin
export default {"root":"Password_root__HaLd7","back":"Password_back__7aKWH","title":"Password_title__z3PU7","input":"Password_input__jd060","button":"Password_button__68OMT"};